import { GETAPPROVERS_SUCCESS, GETAPPROVERS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getApproversReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETAPPROVERS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETAPPROVERS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getApproversReducer;
